<template>
	<div class="template_wrap">
		<div class="search_ipt" v-if="$route.path === '/templateCenter'">
			<el-input
				type="text"
				v-model="keyword"
				:placeholder="searchWord"
				@change="handleSearch"
				@focus="handleFocus"
				@blur="handleBlur"
				@keyup.enter="handleSearch()"
			/>
			<div class="search_icon" @click="handleSearch(keyword)">
				<span class="iconfont icon-search1"></span>
				<div>搜索</div>
			</div>
			<ul class="hot_keyword" v-if="showHotKeyword">
				<div class="header-hot-keywords-title lishijilu">
					<div>
						<i class="iconfont icon-lishijiluicon"></i>
						<span class="lishijilu-text">历史记录</span>
					</div>
					<div class="clearhistory" @click="clear">清空</div>
				</div>
				<div class="hot-keywords-dropdown-title" data-pos="heard">
					<div
						class="heard"
						data-pos="heard"
						v-for="(item, index) in searchKeyWords"
						:key="index"
						@click="handleSearch(item)"
					>
						<span>
							{{ item }}
						</span>
					</div>
				</div>
				<div class="header-hot-keywords-title">
					<div>
						<i class="iconfont icon-remensousuoicon"></i>
						<span class="lishijilu-text">热门搜索</span>
					</div>
				</div>
				<li
					v-for="(item, index) in hotKeyWords"
					:key="item.id"
					class="keyword_item"
					@click="handleSearch(item.keyword)"
				>
					<div>
						<span>{{ index + 1 }}</span>
					</div>
					{{ item.keyword }}
				</li>
			</ul>
		</div>
		<div class="template_content">
			<div class="record_search" v-if="keyword">
				爱设计 >
				<span class="keyword">"{{ keyword }}"</span>
				共
				<span class="number">{{ total }}</span>
				个结果
				<p class="no_result" v-if="!total">
					没有找到
					<span class="keyword">"{{ keyword }}"</span>
					相关的内容，已为您推荐热门内容，您还可以
					<span class="submit" @click="submitInfo">免费提需求</span>
				</p>
			</div>
			<div class="content_searchs">
				<SearchItem
					title="分类"
					type="classify"
					:dataList="classList"
					@getData="handleSearchItem"
				/>
				<SearchItem
					title="场景"
					type="scene_id"
					:dataList="sceneList"
					:defaultOpen="true"
					@getData="handleSearchItem"
				/>
				<SearchItem
					title="用途"
					type="industry_id"
					:dataList="industryList"
					@getData="handleSearchItem"
				/>
				<div class="sort">
					<div class="sort-nav">
						<div
							:class="
								currentSortIndex === index
									? 'sort-item-active sort-item'
									: 'sort-item'
							"
							v-for="(item, index) in sortNav"
							:key="item.name"
							@click="handleSortItem(index)"
						>
							{{ item.name }}
						</div>
					</div>
					<div class="sort-select" v-if="stylesList.length">
						<span>风格：</span>
						<el-select v-model="value" placeholder="全部" @change="selectChange">
							<el-option
								v-for="item in stylesList"
								:key="item.id"
								:label="item.name"
								:value="item.id"
							></el-option>
						</el-select>
					</div>
				</div>
			</div>
			<div
				class="content-container"
				:style="{
					height: containerHeight,
				}"
			>
				<div class="empty" v-if="!templateList.length">
					<img src="@/assets/image/empty.png" alt="" />
				</div>
				<div class="v-waterfall-content" id="v-waterfall" v-else>
					<div
						v-for="(img, index) in templateList"
						:key="index"
						class="v-waterfall-item"
						:style="{
							top: img.top + 'px',
							left: img.left + 'px',
							width: img.new_width + 'px',
							height: img.new_height + 'px',
						}"
					>
						<div class="item-content">
							<img v-lazy="img.cover_url" alt="" />
							<div class="alert-box" @click.self="goDesign(img)">
								<div
									class="preview iconfont icon-preview1"
									@click="preview(img)"
								></div>
								<div
									:class="`collect iconfont icon-collected ${
										img.is_collect ? 'icon-collection' : 'icon-uncollection'
									}`"
									@click="collect(img)"
								></div>
							</div>
							<div class="item-isnew" v-if="img.is_new">
								<div class="isnew-text">新</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<el-pagination
				background
				layout="prev, pager, next"
				:total="total"
				:page-size="50"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import SearchItem from './components/searchItem.vue'
import { TemplateCenter } from '@/config/axios/new_api'
export default {
	data() {
		return {
			sortNav: [
				{
					name: '综合排序',
					key: 5,
				},
				{
					name: '最新上传',
					key: 4,
				},
				{
					name: '最多使用',
					key: 2,
				},
			],
			currentSortIndex: 0, // 当前选中的排序
			classList: [], // 分类
			sceneList: [], // 场景
			industryList: [], // 用途
			stylesList: [], // 风格
			keyword: '', // 搜索词
			hotKeyWords: [], // 热搜词
			showHotKeyword: false, // 是否展示热搜词列表
			searchKeyWords: [], // 历史记录
			templateList: [], // 模板中心列表
			templateParams: {
				page: 1,
				page_size: 50,
				industry_id: 0, // 用途id
				style_id: 0, // 风格id
				sort: 'asc', // 排序 asc或desc
				keyword: '', // 搜索词
				classify: 0, // 分类id
				scene_id: 0, //	场景id
				order: 5, // 排序字段 [最多使用:2  最新上传:4  综合排序:5]
			},
			loading: true,
			containerHeight: 0,
			total: 0,
			value: 0,
			searchWord: '',
		}
	},
	components: {
		SearchItem,
	},
	created() {
		let arr = localStorage.searchKeywords ? localStorage.searchKeywords.split(',') : []
		arr.forEach((item, index) => {
			if (index <= 4) {
				this.searchKeyWords.push(item)
			}
		})
		this.getSearchWord()
		this.getClass()
		this.industry()
		this.styles()
		this.getHotKeyWords()
	},
	mounted() {
		window.onresize = this.throttle(this.waterFall, 200)
		window.scrollTo(0, 0)
		if (this.$route.query.order) {
			let key = this.$route.query.order
			this.sortNav.forEach((item, index) => {
				if (item.key == key) {
					this.currentSortIndex = index
				}
			})
		}
	},
	computed: {},
	methods: {
		async getSearchWord() {
			let res = await TemplateCenter.searchWord()
			if (res.status == 1) {
				res.data.forEach(item => {
					this.searchWord += item.search_word
				})
			}
		},
		// 获取数据
		async getData(unloading) {
			let {
				page,
				classify,
				scene_id,
				industry_id,
				keyword,
				style_id,
				sort,
				order,
			} = localStorage.templateParams ? JSON.parse(localStorage.templateParams) : {}
			this.templateParams.classify = classify || 0
			this.templateParams.scene_id = scene_id || 0
			this.templateParams.industry_id = industry_id || 0
			this.templateParams.keyword = encodeURIComponent(keyword) || ''
			this.templateParams.page = page || 1
			this.templateParams.style_id = style_id || 0
			this.templateParams.sort = sort || 'asc'
			this.templateParams.order = order || 5
			this.value = style_id * 1 || 0
			this.keyword = keyword || ''
			if (!unloading) this.loading = true
			let res = await TemplateCenter.getData(this.templateParams)
			if (res.status == 1) {
				let { data, containerHeight } = this.staticFunc.waterFall(
					res.data ? res.data.data : []
				)
				this.templateList = data
				this.containerHeight = containerHeight
				this.loading = false
				this.total = res.data ? res.data.pagination.total : 0
			}
		},
		async getHotKeyWords() {
			let { data } = await TemplateCenter.hotkeyword()
			this.hotKeyWords = data.data
		},
		// 获取分类
		async getClass() {
			let res = await TemplateCenter.class({})
			this.classList = res.data
			this.getScene()
		},
		// 获取场景
		async getScene(id, type) {
			let { classify, scene_id, empty, keyword } = localStorage.templateParams
				? JSON.parse(localStorage.templateParams)
				: {}
			if (!localStorage.templateParams) {
				classify = this.classList[1].id
			}
			let res = await TemplateCenter.scene({
				class_id: classify || 0,
			})
			// if (!scene_id) {
			// 	scene_id = res.data[1].id
			//     classify == 0 ? 0 : keyword ? 0 : res.data[1].id
			// }
			// if (type) {
			// 	scene_id = id == 0 ? '0' : res.data[1].id
			// 	classify = id
			// }
			this.sceneList = res.data
			this.changeUrl({
				classify,
				scene_id: scene_id && classify == 0 ? scene_id : classify == 0 ? 0 : keyword ? 0 : res.data[1].id,
				page: 1,
			})
		},
		// 获取用途
		async industry() {
			let res = await TemplateCenter.industry()
			this.industryList = res.data
			// this.getData()
		},
		// 获取风格
		async styles() {
			let res = await TemplateCenter.styles()
			this.stylesList = res.data
		},
		handleSearchItem(val) {
			let { type, id } = val
			switch (type) {
				case 'classify':
					this.changeUrl({ classify: id, page: 1 }, 1)
					break
				case 'scene_id':
					this.changeUrl({ scene_id: id, page: 1 })
					break
				case 'industry_id':
					this.changeUrl({ industry_id: id, page: 1 })
					break
			}
		},
		initParams() {
			let defaultparams = {
				page: 1,
				page_size: 50,
				industry_id: 0, // 用途id
				style_id: 0, // 风格id
				sort: 'asc', // 排序 asc或desc
				keyword: '', // 搜索词
				classify: 0, // 分类id
				scene_id: 0, //	场景id
				order: 5, // 排序字段 [最多使用:2  最新上传:4  综合排序:5
			}
			defaultparams = Object.assign(defaultparams, params)
			this.$addStorageEvent('templateParams', JSON.stringify(defaultparams))
		},
		changeUrl(params, getScene) {
			let {
				classify,
				scene_id,
				industry_id,
				style_id,
				sort,
				keyword,
				order,
				page,
			} = localStorage.templateParams ? JSON.parse(localStorage.templateParams) : {}
			let defaultparams = {
				page: page || 1,
				page_size: 50,
				industry_id: industry_id || 0, // 用途id
				style_id: style_id || 0, // 风格id
				sort: sort || 'asc', // 排序 asc或desc
				keyword: keyword || '', // 搜索词
				classify: classify || 0, // 分类id
				scene_id: scene_id || 0, //	场景id
				order: order || 5, // 排序字段 [最多使用:2  最新上传:4  综合排序:5
			}
			defaultparams = Object.assign(defaultparams, params)
			this.$addStorageEvent('templateParams', JSON.stringify(defaultparams))
			if (getScene) {
				this.getScene()
				return
			}
			this.getData()
		},
		currentChange(page) {
			this.changeUrl({ page })
			window.scrollTo(0, 0)
		},
		selectChange(val) {
			this.loading = true
			this.changeUrl({ style_id: val })
		},
		waterFall() {
			let { data, containerHeight } = this.staticFunc.waterFall(this.templateList)
			this.templateList = data
			this.containerHeight = containerHeight
		},
		/**
		 * 函数节流方法
		 * @param Function fn 延时调用函数
		 * @param Number delay 延迟多长时间
		 * @param Number atleast 至少多长时间触发一次
		 * @return Function 延迟执行的方法
		 */
		throttle(fn, delay, atleast) {
			var timer = null
			var previous = null
			return function () {
				var now = +new Date()
				if (!previous) previous = now
				if (now - previous > atleast) {
					fn()
					// 重置上一次开始时间为本次结束时间
					previous = now
				} else {
					clearTimeout(timer)
					timer = setTimeout(function () {
						fn()
					}, delay)
				}
			}
		},
		goDesign(item) {
			this.goDesignworkbench(item, item.id, 'templatecenter')
		},
		// 预览模板
		preview(val) {
			window.open(`/templateCenterDetail?templateId=${val.id}&type=${val.type}`, '_blank')
		},
		// 收藏模板
		async collect(val) {
			if (val.is_collect) {
				let res = await TemplateCenter.uncollect({
					designer_template_id: val.id,
				})
				if (res.status == 1) {
					this.$message.success('取消收藏成功')
				} else {
					this.$message.error(res.error)
				}
			} else {
				let res = await TemplateCenter.collect({
					designer_template_id: val.id,
				})
				if (res.status == 1) {
					this.$message.success('收藏成功')
				} else {
					this.$message.error(res.error)
				}
			}
			this.getData('unloading')
		},
		handleSortItem(ind) {
			let { key } = this.sortNav.filter((item, index) => index === ind)[0]
			this.loading = true
			this.currentSortIndex = ind
			this.changeUrl({ order: key })
		},
		submitInfo() {
			this.$router.push('/demand')
		},
		handleSearch(val) {
			if (val) {
				let index = this.searchKeyWords.indexOf(val)
				if (index !== -1) {
					this.searchKeyWords.splice(index, 1)
				}
				this.searchKeyWords.unshift(val)
				if (this.searchKeyWords.length > 5) {
					this.searchKeyWords.splice(this.searchKeyWords.length - 1, 1)
				}
				window.localStorage.setItem('searchKeywords', this.searchKeyWords)
			}
			this.loading = true
			this.keyword = val
			this.showHotKeyword = false
			this.changeUrl({ keyword: val, classify: 0, scene_id: 0, industry_id: 0, order: 5 }, 1)
		},
		clear() {
			this.searchKeyWords = []
			window.localStorage.removeItem('searchKeywords')
		},
		handleFocus(ev) {
			this.showHotKeyword = true
		},
		handleBlur(ev) {
			setTimeout(() => {
				this.showHotKeyword = false
			}, 200)
		},
	},
	beforeDestroy() {
		localStorage.removeItem('templateParams')
	},
}
</script>

<style lang="scss" scoped>
.search_ipt {
	width: 300px;
	height: 40px;
	display: flex;
	position: fixed;
	top: 10px;
	z-index: 999;
	left: 230px;
	::v-deep( .el-input) {
		.el-input__inner {
			padding-right: 75px;
		}
	}
	.search_icon {
		width: 65px;
		height: 100%;
		font-size: 14px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #9695a7;
		cursor: pointer;
		position: absolute;
		right: 10px;
		span {
			margin-right: 3px;
			font-size: 18px;
			margin-top: 2px;
		}
	}
	.header-hot-keywords-title {
		margin-top: 4px;
		margin-bottom: 10px;
		display: flex;
		align-items: center;
		padding-left: 12px;
		justify-content: space-between;
		padding-right: 20px;
		.icon-remensousuoicon {
			color: #f83b31;
		}
		.icon-lishijiluicon {
			color: #9695a7;
		}
		.clearhistory {
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #9695a7;
			line-height: 20px;
			cursor: pointer;
		}
		.lishijilu-text {
			margin-left: 7px;
			font-size: 16px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #3b3946;
			line-height: 22px;
		}
	}
	.hot-keywords-dropdown-title {
		position: relative;
		.heard {
			span {
				display: inline-block;
				padding-left: 0;
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				cursor: pointer;
				color: #3b3946;
				background: #f8f8f8;
				padding: 8px 10px;
				margin-left: 12px;
				margin-bottom: 10px;
				border-radius: 4px;
			}
		}
	}
	.hot_keyword {
		width: 300px;
		padding-top: 10px;
		position: absolute;
		top: 40px;
		left: 0;
		width: 300px;
		padding-bottom: 10px;
		max-height: 640px;
		overflow: auto;
		background: #ffffff;
		border-radius: 8px;
		box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.03);
		li {
			height: 35px;
			font-size: 16px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #6e6d7f;
			line-height: 35px;
			cursor: pointer;
			overflow: hidden;
			div {
				position: relative;
				display: block;
				width: 18px;
				height: 18px;
				background: #5a2df5;
				border-radius: 3px;
				margin-top: 9px;
				margin-left: 12px;
				line-height: 18px;
				float: left;
				margin-right: 6px;
				text-align: center;
				font-size: 14px;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
				color: #ffffff;
			}
			&:nth-child(4) {
				div {
					background-color: #f83b31;
				}
			}
			&:nth-child(5) {
				div {
					background-color: #ff6f24;
				}
			}
			&:nth-child(6) {
				div {
					background-color: #ffa123;
				}
			}
		}
	}
}
.template_wrap {
	width: calc(100% - 200px);
	min-height: calc(100vh - 60px);
}
.template_content {
	width: 100%;
	min-height: 100%;
	display: flex;
	flex-direction: column;
	.record_search {
		width: 100%;
		padding: 10px 20px;
		color: #9695a7;
		font-size: 14px;
		display: flex;
		align-items: center;
		.keyword {
			color: #3c3c43;
			padding: 0 5px;
		}
		.number {
			color: #5a2df5;
		}
		.no_result {
			margin-left: 20px;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.submit {
			width: 90px;
			height: 30px;
			background: #ffffff;
			border-radius: 4px;
			border: 1px solid #5a2df5;
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #5a2df5;
			line-height: 20px;
			cursor: pointer;
			margin-left: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
	.content_searchs {
		padding: 0 20px;
	}
	.content-container {
		min-height: calc(100vh - 450px);
		::v-deep( .el-loading-mask) {
			height: 100%;
			.el-loading-spinner {
				top: 200px !important;
			}
		}
	}
}
.sort {
	width: 100%;
	line-height: 71px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: bold;
	font-size: 14px;
	display: flex;
	padding: 0;
	.sort-nav {
		display: flex;
		position: relative;
		.sort-item {
			font-family: PingFangSC-Regular, PingFang SC;
			margin-right: 24px;
			color: #6e6d7f;
			cursor: pointer;
			user-select: none;
			font-weight: 400;
		}
		.sort-item-active {
			color: #3b3946;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: bold;
		}
		&::after {
			content: '';
			display: block;
			position: absolute;
			right: 0;
			top: 29px;
			width: 1px;
			height: 14px;
			background-color: #000;
		}
	}
	.sort-select {
		margin-left: 24px;
		span {
			color: #3b3946;
		}
		::v-deep( .el-select) {
			width: 90px;
			margin-left: 10px;
			height: 40px;
			.el-input {
				height: 40px;
				.el-input__inner {
					border: none;
					padding: 0;
				}
				.el-input__suffix {
					margin-top: -1px;
				}
			}
		}
	}
}
.empty {
	width: 100%;
	height: calc(100vh - 450px);
	display: flex;
	justify-content: center;
	align-items: center;
	img {
		width: 240px;
		height: 240px;
	}
}
.v-waterfall-content {
	width: 100%;
	min-height: 100%;
	position: relative;
}

.v-waterfall-item {
	float: left;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 30px;
	font-weight: 700;
	color: aliceblue;
	position: absolute;
	transition: all 0.5s ease-in-out;
	&:hover {
		cursor: pointer;
	}
	.item-content {
		width: 100%;
		height: 100%;
		position: relative;
		img {
			width: 100%;
			max-width: 100%;
			max-height: 100%;
			border-radius: 4px;
		}
		.alert-box {
			display: none;
		}
		&:hover {
			.alert-box {
				display: block;
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
				background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, transparent 100%);
				box-shadow: 0px 2px 10px 0px;
				.preview {
					position: absolute;
					top: 10px;
					cursor: pointer;
					text-align: center;
					background: #fff;
					line-height: 28px;
					right: 46px;
					left: auto;
					color: #333;
					font-size: 24px;
					width: 30px;
					height: 30px;
					background: #ffffff;
					border-radius: 4px;
				}
				.collect {
					position: absolute;
					top: 10px;
					cursor: pointer;
					text-align: center;
					width: 30px;
					height: 30px;
					border-radius: 4px;
					right: 10px;
					color: #333333;
					background-color: #fff;
					line-height: 30px;
				}
				.preview:hover,
				.collect:hover {
					background: #e1dfea;
				}
				.icon-collection {
					color: #e54b4b;
				}
				.icon-uncollection {
					color: #333333;
				}
			}
		}
		.item-isnew {
			top: 0;
			left: 0;
			width: 34px;
			height: 34px;
			overflow: hidden;
			border-top-left-radius: 0;
			position: absolute;
			.isnew-text {
				color: #fff;
				z-index: 1;
				position: absolute;
				left: 3px;
				top: 1px;
				font-size: 14px;
				font-weight: normal;
			}
			&::after {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				width: 0;
				height: 0;
				border-top: 34px solid red;
				border-right: 34px solid transparent;
			}
		}
	}
}
.el-pagination {
	text-align: center;
	margin-bottom: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	/deep/ .btn-next,
	/deep/ .btn-prev {
		width: 76px;
		height: 32px;
		line-height: 32px;
		border-radius: 4px;
		border: 1px solid #dedede;
		position: relative;
		background: #fff;
		color: #999;
		.el-icon {
			display: inline-block;
			position: absolute;
		}
	}
	::v-deep( .btn-prev .el-icon) {
		left: 10px;
		top: 11px;
	}
	::v-deep( .btn-next .el-icon) {
		right: 10px;
		top: 11px;
	}
}
::v-deep( .el-pagination .btn-prev::after) {
	content: '上一页';
	position: absolute;
	left: 23px;
	top: 0;
}
::v-deep( .el-pagination .btn-next::after) {
	content: '下一页';
	position: absolute;
	right: 23px;
	top: 0;
}
</style>
